import { create } from "zustand";

import type { GoogleEmbed } from "@domain/google-embed";

/** A document surfaced in chat that can open in the side panel. The `app`
 *  payload is identity-only (path-as-identity, studio spec R3): the panel's
 *  fetch container resolves `appDir` → files via the studio hooks. */
export type Artifact =
  | { kind: "google"; label: string; embed: GoogleEmbed }
  | { kind: "pdf"; label: string; url: string }
  | { kind: "markdown"; label: string; content: string }
  | { kind: "app"; label: string; appDir: string };

interface ArtifactState {
  artifact: Artifact | null;
  isOpen: boolean;
  openArtifact: (artifact: Artifact) => void;
  close: () => void;
}

/** Ephemeral UI state for the document side panel (one artifact at a time). */
export const useArtifactStore = create<ArtifactState>((set) => ({
  artifact: null,
  isOpen: false,
  openArtifact: (artifact) => set({ artifact, isOpen: true }),
  close: () => set({ isOpen: false }),
}));
